/**
 * 日期时间格式化
 *
 * @param {(Object|string|number)} time
 * @param {string} format
 * @returns {string | null}
 */
export function dateFormat(time, format) {
  if (time) {
    // 默认格式：年月日时分秒
    format = format || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
        time = parseInt(time)
      }
      // if ((typeof time === 'number') && (time.toString().length === 10)) {
      //   time = time * 1000
      // }
      time = time * 1000
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds()
    }
    return format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key]
      return value.toString().padStart(2, '0')
    })
  } else {
    return ''
  }
}
function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

/**
 * 生成随机文件名称
 * @param {string} classify
 * @param {(string|number)} len
 * @returns {string}
 */
export const getFileName = (classify, len = 32) => {
  const date = new Date()
  const dirDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let randomStr = ''
  for (let i = 0; i < len; i++) {
    randomStr += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return `${classify ? classify + '_' : ''}${dirDate}_${randomStr}`
}

/**
 * 复制到剪切板
 * @param {string} str
 * @param {function} cb
 */
export const copyString = (str, cb) => {
  const input = document.createElement('input')
  input.value = str
  input.readOnly = true
  document.body.appendChild(input)
  input.select()
  input.setSelectionRange(0, input.value.length)
  document.execCommand('Copy')
  document.body.removeChild(input)
  window.scrollTo(0, 0)
  cb instanceof Function && cb()
}

/**
 * 邮箱验证
 * @param {string} email
 * @returns {Boolean}
 */
export const isEmail = (email) => {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * 金额验证，10位小数
 * @param {(string|number)} amount
 * @returns {Boolean}
 */
export const isAmount = (amount) => {
  const reg = /^[0-9]+(.[0-9]{1,10})?$/
  return reg.test(amount)
}

/**
 * 金额多位小数验证
 * @param {(string|number)} amount
 * @returns {Boolean}
 */
export const isAmountNum = (amount) => {
  const reg = /^\+?\d+(\.\d+)?$/
  return reg.test(amount)
}

/**
 * 截取小数点后六位（不四舍五入）
 * @param {(string)} amount
 * @returns {Boolean}
 */
export const getnum = (num) => {
  if (!num) return '0.000000'
  num = num.toString()
  const result = num.substring(0, num.indexOf('.') + 11)
  return result
}

/**
 * 数值放大1000000倍，用于比较
 * @param {(string)} amount
 * @returns {Boolean}
 */
export const numEnlarge = (num, index = 6) => {
  const length = num.length - 1 - num.indexOf('.')
  if (length < index) return parseFloat(num.replace('.', '')) * Math.pow(10, length)
  else if (length > index) {
    const num2 = num.replace('.', '')
    const i = num.indexOf('.') + index
    const newNum = num2.slice(0, i) + '.' + num2.slice(i)
    return parseFloat(newNum)
  } else return parseFloat(num.replace('.', ''))
}

/**
 * 获取日期范围(七天)
 *
 * @returns {object}
 */
export const getDateRange = () => {
  const Time = new Date()
  const dateTime = Time.setDate(Time.getDate() + 1)
  const startTime = Time.setDate(Time.getDate() - 8)
  const start_time = dateFormat(new Date(startTime), '{y}-{m}-{d}') + ' 00:00:00'
  const end_time = dateFormat(new Date(dateTime), '{y}-{m}-{d}') + ' 23:59:59'
  return { start_time: start_time, end_time: end_time }
}
export const getDateRanges = () => {
  const Time = new Date()
  const dateTime = Time.setDate(Time.getDate())
  const startTime = new Date(Time.getFullYear(), Time.getMonth(), 1)
  const start_time = dateFormat(new Date(startTime), '{y}-{m}-{d}') + ' 00:00:00'
  const end_time = dateFormat(new Date(dateTime), '{y}-{m}-{d}') + ' 23:59:59'
  return { start_time: start_time, end_time: end_time }
}

// 截取小数点后N位数字
export const truncateDecimal = (num, m = 2) => {
  let val = num.toString();
  //只保留第一个. 清除多余的
  val = val.replace(/\.{2,}/g, '.');
  val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
  //只能输入两个小数
  val = val.replace(new RegExp(`^(\\-)*(\\d+)\\.(\\d{${m}}).*$`), '$1$2.$3')
  if (val.indexOf('.') < 0 && val != '') {
    //如果没有小数点，首位不能为类似于 01、02的金额
    val = parseFloat(val)
  }
  return val;
}


// 只允许数字
export const onlyNumbers = (num) => {
  let n = num;
  n = n.replace(/[^\d.]/g, "");
  n = n.replace(/^\./g, "");
  n = n.replace(/\.{2,}/g, ".");
  n = n.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  return n
}

export const toolNumber = (num_str) => {
  num_str = num_str.toString();
  if (num_str.indexOf("+") != -1) {
    num_str = num_str.replace("+", "");
  }
  if (num_str.indexOf("E") != -1 || num_str.indexOf("e") != -1) {
    var resValue = "",
      power = "",
      result = null,
      dotIndex = 0,
      resArr = [],
      sym = "";
    var numStr = num_str.toString();
    if (numStr[0] == "-") {
      // 如果为负数，转成正数处理，先去掉‘-’号，并保存‘-’.
      numStr = numStr.substr(1);
      sym = "-";
    }
    if (numStr.indexOf("E") != -1 || numStr.indexOf("e") != -1) {
      var regExp = new RegExp(
        "^(((\\d+.?\\d+)|(\\d+))[Ee]{1}((-(\\d+))|(\\d+)))$",
        "ig"
      );
      result = regExp.exec(numStr);
      if (result != null) {
        resValue = result[2];
        power = result[5];
        result = null;
      }
      if (!resValue && !power) {
        return false;
      }
      dotIndex = resValue.indexOf(".") == -1 ? 0 : resValue.indexOf(".");
      resValue = resValue.replace(".", "");
      resArr = resValue.split("");
      if (Number(power) >= 0) {
        var subres = resValue.substr(dotIndex);
        power = Number(power);
        //幂数大于小数点后面的数字位数时，后面加0
        for (var i = 0; i <= power - subres.length; i++) {
          resArr.push("0");
        }
        if (power - subres.length < 0) {
          resArr.splice(dotIndex + power, 0, ".");
        }
      } else {
        power = power.replace("-", "");
        power = Number(power);
        //幂数大于等于 小数点的index位置, 前面加0
        for (var i = 0; i < power - dotIndex; i++) {
          resArr.unshift("0");
        }
        var n = power - dotIndex >= 0 ? 1 : -(power - dotIndex);
        resArr.splice(n, 0, ".");
      }
    }
    resValue = resArr.join("");

    return sym + resValue;
  } else {
    return num_str;
  }
}


/**
 * 判断设备
 * 
 * 
 */
export const detect = () => {
  var equipmentType = " ";
  var agent = navigator.userAgent.toLowerCase();
  //android ios windows
  var android = agent.indexOf("android");
  var iphone = agent.indexOf("iphone");
  var ipad = agent.indexOf("ipad");
  var windows = agent.indexOf("windows");
  var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
  if (android != -1) {
    equipmentType = "android";
  }
  if (iphone != -1 || ipad != -1 || isMac) {
    equipmentType = "ios";
  }
  if (windows != -1) {
    equipmentType = "windows";
  }
  return equipmentType;
}

/**
 * 彩票组数排列
 * @param {Array} nu
 * @param {(string|number)} groupl
 * @returns {Array}
 */
export const LotteryRanking = (nu, groupl, result) => {
  var result = result ? result : [];
  var nuc = nu.slice(0);
  var item = nuc.shift();
  item = item.constructor === Array ? item : [item];
  (function func(item, nuc) {
    var itemc;
    var nucc = nuc.slice(0);
    var margin = groupl - item.length;
    if (margin == 0) {
      result.push(item);
      return;
    }
    if (margin == 1) {
      for (var j in nuc) {
        itemc = item.slice(0);
        itemc.push(nuc[j]);
        result.push(itemc);
      }
    }
    if (margin > 1) {
      itemc = item.slice(0);
      itemc.push(nucc.shift());
      func(itemc, nucc);
      if (item.length + nucc.length >= groupl) {
        func(item, nucc);
      }
    }
  })(item, nuc);
  if (nuc.length >= groupl) {
    return LotteryRanking(nuc, groupl, result);
  } else {
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js